<template>
  <div
    class="font-family-selection"
    @keydown.stop="">
    <label class="mb-4">{{ label }}</label>

    <multi-select
      :options="getOptions"
      :show-labels="false"
      :allow-empty="false"
      :preserve-search="true"
      :placeholder="getValue.name"
      :reset-after="true"
      :preselect-first="false"
      :clear-on-select="false"
      :max-height="240"
      v-model="getValue"
      label="name"
      select-label="''"
      track-by="name"
      @select="changeFontName">
      <span slot="noResult">No results matched</span>
      <template
        slot="option"
        slot-scope="props">
        <div>
          <span :style="{fontFamily:JSON.stringify(props.option.name)}">{{ props.option.name }}</span>
          <span
            v-tooltip="'Click to remove from Favourite'"
            v-if="props.option.isFavourite && props.option.id.length > 0"
            class="star"
            @click.stop="changeFavourite(props.option.id, false)"> <icon :name="'star-favourite'"/></span>
          <span
            v-tooltip="'Click to Add to Favourite'"
            v-if="!props.option.isFavourite && props.option.id.length > 0"
            class="star"
            @click.stop="changeFavourite(props.option.id, true)"> <icon :name="'star-un-favourite'"/></span>
        </div>
      </template>
      <template
        slot="singleLabel"
        slot-scope="props">
        <div>
          <span>{{ props.option.name }}</span>
        </div>
      </template>
    </multi-select>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import axios from 'axios';
import { cloneDeep } from 'lodash'; // TDOD: Change to @/

export default {
  name:       'FontFamilySelector',
  components: { 'multi-select': Multiselect },
  props:      {
    label: String,
    value: String,
  },
  data() {
    return { options: [] };
  },
  computed: {
    getValue:
    {
      get() {
        return { name: this.value.replace(/"/g, '').split(',')[0] };
      },
      set(value) {},

    },
    getOptions() {
      const optionList = cloneDeep(this.$store.getters.getproductfontarray);
      optionList.sort((a, b) => {
        if (a.isFavourite) { return -1; }
        if (b.isFavourite) { return 1; }
        return 0;
      });
      return optionList.map(element => ({ name: element.name, isFavourite: element.isFavourite, id: element.id }));
    },
  },
  mounted() {
    this.options =  this.$store.getters.getproductfontarray.map(element => ({ name: element.name, isFavourite: element.isFavourite, id: element.id }));
  },
  methods: {
    changeFavourite(fontId, isFavourite) {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : null;
      const domainUrl          = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url                = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=SetFontAsFavourite&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/&fontId=${fontId}&userId=${userId}&isFavourite=${isFavourite}`;
      axios.get(url)
        .then((response) => {
          console.log(response);
          const parser       = new DOMParser();
          const xmlParsed    = parser.parseFromString(response.data, 'text/xml');
          const result       = xmlParsed.getElementsByTagName('SetFontAsFavouriteResult');
          const parsedResult = JSON.parse(result[0].textContent);
          if (parsedResult) {
            this.$store.commit('changeFontFavouriteAttribute', { fontId, isFavourite });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    changeFontName(e) {
      if (!e.name) { return; }
      EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_FAMILY, e.name);
    },
    reomveDuplicationFromArrayOfObject(objectArray) {
      return [...objectArray.reduce((map, obj) => map.set(obj.name, obj), new Map()).values()];
    },


  },
};
</script>
<style lang="scss">

.multiselect {
  &:hover {
    .multiselect__tags {
      border-color: $grey40;
    }
  }
  span{
    &.star{
      position: absolute;
      right: -25px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  min-height: 36px;

  .multiselect__tags {
    height: 36px;
    min-height: 0px;
    border: 1px solid $grey20;
    padding: 6px 16px;
  }

  .multiselect__content-wrapper {
    overflow-x: hidden;
  }

  .multiselect__option--highlight {
    background-color: $blue10;
    color: $blue50;
  }


  .multiselect__input {
    border: none;
    font-size: 14px;
    padding: 0px;
    margin: 0;
    line-height: normal;
    min-height: 0;

    &::placeholder {
      font-size: 14px;
      line-height: 24px;
      color: $grey40;
      cursor: default;
    }
  }

  .multiselect__select {
    &:before {
      top: auto;
      margin-top: 0px;
      border: none;
      background-image: url('../../assets/images/Vector.png');
      height: 16px;
      width: 16px;
      background-repeat: no-repeat;
      background-position: center center;
    }

    height: 16px;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    bottom: 0px;
    width: 16px;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
  }

  .multiselect__placeholder {
    color: $grey40;
    padding: 0px;
    margin-bottom: 0px;
  }

  .multiselect__single {
    font-size: 14px;
    line-height: 24px;
    color: $grey80;
    margin: 0;
    padding: 0;
  }

  .multiselect__element {
    font-size: 14px;
    line-height: 24px;
    color: $grey80;
    width: 90%;
  }

  .multiselect__option {
    padding: 6px 16px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    white-space: normal;
  }

  .multiselect__content-wrapper {
    border-radius: 0px 0px 4px 4px;
  }

  .multiselect__option {
    font-size: 14px;
  }

  .multiselect__option--selected {
    color: $blue10;
    background-color: $blue50;
    font-weight: normal;
    &:after{
      content: '\2713';
      color: white;
    }
    &.multiselect__option--highlight {
      &::after{
        background: $blue50;
      }

    }
  }
}


.multiselect--active {
  &:hover {
    .multiselect__tags {
      border-color: $blue50;
    }
  }

  .multiselect__tags {
    border-color: $blue50;
    border-bottom: 0px;
  }

  .multiselect__content-wrapper {
    border: 1px solid $blue50;
  }

  .multiselect__select {
    &:before {
      transform: rotate(180deg);
    }
  }

  .multiselect__placeholder {
    margin-bottom: 0px;
    padding-bottom: 0px;
  }

}

.dropdown-selection-font {
  visibility: hidden !important;
}

.show-content {
  .dropdown-selection {
    visibility: visible !important;
  }

  .custom-icon {
    transform: rotate(-180deg) !important;
  }
}

.height {
  height: 180px;
  overflow-y: scroll;
}
</style>
